import React from 'react'
import { makeStyles, Grid, Typography, Chip, Button } from '@material-ui/core'
import { urls } from '../../utils/config'

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#211A29',
    padding: '80px 20px',
    margin: 'auto',
    [theme.breakpoints.up('sm')]: {
      padding: '80px 120px',
    },
  },
  header: {
    color: 'white',
    margin: '2rem 0',
    letterSpacing: '-0.02em',
    [theme.breakpoints.down('sm')]: {
      fontSize: '52px',
    },
  },
  chip: {
    background: 'rgba(11, 11, 11, 0.8)',
    color: 'white',
  },
  link: {
    color: 'white',
    fontSize: '.8rem',
    padding: '.4rem 0',
    borderBottom: '1px solid white',
  },
  contentSection: {
    margin: '1rem 0',
    '& p': {
      color: 'white',
      margin: '1rem 0',
    },
    '& h3': {
      color: 'white',
      letterSpacing: '-0.02em',
      margin: '1rem 0',
      fontSize: '3rem',
    },
  },
  videoWrapper: {
    position: 'relative',
    height: '360px',
    overflow: 'hidden',
    borderRadius: '1rem',

    '& iframe': {
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
    },
  },
  heroCTA: {
    textTransform: 'unset',
    margin: '1rem 1rem 1rem 0',
  },
}))

interface props {
  chip: {
    label: string
  }
  header: string
  title: string
  content: string
  video: string
  cta: {
    label: string
    url: string
  }
}

export default function LearnMore({
  chip,
  header,
  title,
  content,
  video,
  cta,
}: props): JSX.Element {
  const classes = useStyles({})
  return (
    <div className={classes.root}>
      <Chip label={chip.label} className={classes.chip} />
      <Typography variant="h1" className={classes.header}>
        {header}
      </Typography>

      <div>
        <Grid container className={classes.contentSection} spacing={2} wrap="wrap">
          <Grid item xs={12} md={6}>
            <Typography variant="h3">{title}</Typography>
            <Typography variant="body2">{content}</Typography>

            <Button color="primary" variant="contained" href={cta.url} className={classes.heroCTA}>
              {cta.label}
            </Button>
          </Grid>
          <Grid item xs={12} md={6}>
            <div>
              <div className={classes.videoWrapper}>
                <iframe
                  width="560"
                  height="315"
                  src={video}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  )
}

LearnMore.defaultProps = {
  chip: {
    label: 'Academy',
  },
  header: 'Learn more about crypto',
  title: 'Exchanges explained!',
  content: `If you’re a crypto-trading beginner, look for a platform with a simple and
  straightforward interface. A good exchange starts simple, and hides complex features
  for advanced traders in the settings.`,
  video: 'https://www.youtube.com/embed/GE1-FK1-YFw',
  cta: {
    label: 'Learn more about exchanges',
    url: urls.academy,
  },
}
